import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { Provider } from 'react-redux';
import store from './store/index';
import { ToastHost } from './components/Toast';
import { registerInertiaErrorHandlers } from './utils/inertiaErrorHandlers';

import './tailwind.css';
import './i18n';
import 'react-perfect-scrollbar/dist/css/styles.css';

// Remplace la modale HTML brute d'Inertia par un message comprehensible (session expiree, erreur serveur...).
registerInertiaErrorHandlers();

const pages = import.meta.glob('./pages/**/*.tsx');

void createInertiaApp({
  resolve: async (name: string) => {
    const page = pages[`./pages/${name}.tsx`] as (() => Promise<unknown>) | undefined;

    if (!page) {
      throw new Error(`Page Inertia introuvable: ${name}`);
    }

    const module : any = await page();
    return module.default;
  },

  setup({ el, App, props }) {
    // Pas de <React.StrictMode> : le double montage de developpement reinitialise les widgets
    // imperatifs (DataTables / jQuery) et provoque "Cannot reinitialise DataTable".
    // StrictMode n'a aucun effet sur le build de production : la page en recette n'est pas impactee.
    createRoot(el).render(
      <Suspense fallback={<div>Loading...</div>}>
        <Provider store={store}>
          {/* Notifications ephemeres : montees hors page Inertia, elles survivent aux navigations. */}
          <ToastHost />
          <App {...props} />
        </Provider>
      </Suspense>
    );
  },
});
